import React, { FC } from 'react';
import { styled } from '@material-ui/core';
import { Environment, getEnvironment } from '@/services/config';
import { getAuthTokenFromStorage } from '@/services/utils';

const StyledLink = styled('div')({
  display: 'flex',
  padding: '9px 16px 9px 32px',
  'align-items': 'center',
  'border-top-right-radius': '30px',
  'border-bottom-right-radius': '30px',
  'margin-right': '16px',
  cursor: 'pointer',

  '&:hover': {
    color: 'rgba(0, 0, 0, 0.87)',
    'background-color': 'rgb(229, 229, 229)',
  },
});

const ProductConfigurationLink : FC = () => {
  function onClick() {
    const environment = getEnvironment();
    const authToken = getAuthTokenFromStorage();

    switch (environment) {
      case Environment.DEVELOPMENT: {
        // If you need to test both houstons at the same time, run the second one on a different port
        window.open(`http://localhost:5003/login?redirect=/properties#access_token=${authToken}`, '_blank');

        break;
      }

      case Environment.STAGING: {
        window.open(`https://houston2.staging-bobw.com/login?redirect=/properties#access_token=${authToken}`, '_blank');

        break;
      }

      case Environment.PRODUCTION: {
        window.open(`https://houston2.bobw.co/login?redirect=/properties#access_token=${authToken}`, '_blank');

        break;
      }

      case Environment.DUKE_NUKEM: {
        window.open(`https://houston2.dukenukem.test-bobw.com/login?redirect=/properties#access_token=${authToken}`, '_blank');

        break;
      }
    }
  }

  return (
    <StyledLink
      onClick={onClick}
    >
      Products configuration
    </StyledLink>
  );
};

export default ProductConfigurationLink;
